import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface TimeLeft {
  days: number;
  hours: string;
  mins: string;
}

function getTimeToEnforcement(): TimeLeft {
  const target = new Date('2026-01-01T00:00:00Z').getTime();
  const diff = target - Date.now();
  if (diff <= 0) return { days: 0, hours: '00', mins: '00' };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: String(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
    mins: String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
  };
}

export default function CBAMUrgency(): React.ReactElement {
  const [time, setTime] = useState<TimeLeft>(getTimeToEnforcement);

  useEffect(() => {
    const interval = setInterval(() => setTime(getTimeToEnforcement()), 30_000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="cbam-urgency" id="cbam-urgency">
      <div className="container">
        <div className="cbam-grid">
          <div>
            <p className="cbam-eyebrow">&#128197; CBAM Full Enforcement</p>
            <h2 className="cbam-headline">
              Know the carbon in what you import.<br />
              Before the EU charges you for not knowing.
            </h2>
            <p className="cbam-subtext">
              From January 2026, EU importers of covered goods must hold CBAM certificates to cover
              embedded emissions. Non-compliance carries financial penalties. Most importers are
              discovering their suppliers don&rsquo;t have the required data &mdash; and that
              assembling it manually is an exercise in risk.
            </p>
          </div>

          <div className="cbam-cta-col">
            <div className="cbam-timer">
              <p className="cbam-timer-label">Time to full enforcement</p>
              <div className="cbam-timer-digits">
                <div className="cbam-timer-seg">
                  {time.days}<small>days</small>
                </div>
                <div className="cbam-timer-seg" style={{ opacity: 0.5 }}>:</div>
                <div className="cbam-timer-seg">
                  {time.hours}<small>hrs</small>
                </div>
                <div className="cbam-timer-seg" style={{ opacity: 0.5 }}>:</div>
                <div className="cbam-timer-seg">
                  {time.mins}<small>min</small>
                </div>
              </div>
            </div>
            <Link to="/platform#cbam" className="btn-white">
              See how Actula handles CBAM &rarr;
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
